<header
  [ngClass]="{'header-background': isBackground}">

  <div class="container d-flex align-items-center p-3 mb-4">
    <div class="logo-container">
      <img src="../../../../assets/img/logo-bsafe.svg" alt="Besafe logo">
    </div>

    <!-- <div class="menu-container">
      <a
        [routerLink]="['/']"
        class="menu-item p-3"
        i18n="Home menu item@@home-menu-item">Home</a>
      <a
        href="#"
        class="menu-item p-3"
        i18n="Media menu item@@menu-menu-item">Media</a>
      <a
        href="#"
        class="menu-item p-3"
        i18n="Testimonials menu item@@testimonials-menu-item">Testimonials</a>
      <a
        [routerLink]="['/auth/login']"
        class="menu-item p-3"
        i18n="Login/Register menu item@@login-register-menu-item">Login/Register</a>
    </div> -->
  </div>
</header>